import { Card } from 'antd';
import { ReactNode } from 'react';

const OrderBodyMessage = ({ children }: { children: ReactNode }) => {
    return (
        <Card className="p-5 pt-2 shadow mb-5 bg-white">
            <div className="d-grid w-100 pt-4 gap-3">
                <div className="d-flex justify-content-center align-items-center fs-5 text-black-50">
                    {children}
                </div>
            </div>
        </Card>
    );
};

export default OrderBodyMessage;
